(() => {
  const attributionKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  const attributionStorageKey = 'aurasync_attribution';
  const currentAttribution = attributionKeys.reduce((values, key) => {
    const value = new URLSearchParams(window.location.search).get(key);
    if (value) values[key] = value.slice(0, 200);
    return values;
  }, {});
  let storedAttribution = {};
  try {
    storedAttribution = JSON.parse(localStorage.getItem(attributionStorageKey) || '{}');
  } catch (_) {
    storedAttribution = {};
  }
  const attribution = { ...storedAttribution, ...currentAttribution };
  if (Object.keys(currentAttribution).length) {
    localStorage.setItem(attributionStorageKey, JSON.stringify(attribution));
  }
  if (Object.keys(attribution).length) {
    window.posthog?.register?.(attribution);
    const landingReceipt = `${attribution.utm_campaign || ''}:${attribution.utm_content || ''}`;
    if (landingReceipt !== ':' && sessionStorage.getItem('aurasync_social_landing') !== landingReceipt) {
      window.posthog?.capture?.('aurasync_social_landing', attribution);
      sessionStorage.setItem('aurasync_social_landing', landingReceipt);
    }
    const cartAttributes = Object.fromEntries(
      Object.entries(attribution).map(([key, value]) => [`aurasync_${key}`, value])
    );
    fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: cartAttributes }),
    }).catch(() => {});
  }

  const root = document.documentElement;
  const toast = document.querySelector('[data-aura-toast]');
  const loader = document.querySelector('[data-aura-loader]');
  const baseline = document.querySelector('[data-aura-baseline]');
  const themeButton = document.querySelector('[data-aura-theme-toggle]');
  const header = document.querySelector('[data-aurasync-header]');
  const drawer = document.querySelector('[data-aurasync-drawer]');
  const openButton = document.querySelector('[data-aurasync-menu-open]');
  const closeButtons = document.querySelectorAll('[data-aurasync-menu-close]');
  const midnightBanner = document.querySelector('[data-aura-midnight-banner]');

  if (midnightBanner) midnightBanner.hidden = true;

  const setTheme = (theme) => {
    root.dataset.auraTheme = theme;
    themeButton?.setAttribute('aria-label', theme === 'shutdown' ? 'Exit Shutdown Mode' : 'Enter Shutdown Mode');
    themeButton?.setAttribute('title', theme === 'shutdown' ? 'Exit Shutdown Mode' : 'Enter Shutdown Mode');
    if (themeButton) themeButton.textContent = theme === 'shutdown' ? '☀' : '☾';
    localStorage.setItem('aurasync-theme', theme);
  };

  const showToast = (quantity = 1) => {
    if (!toast) return;
    toast.querySelector('span').textContent = `${quantity} item${quantity === 1 ? '' : 's'} added to your cart.`;
    toast.classList.add('is-visible');
    toast.setAttribute('aria-hidden', 'false');
    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(() => {
      toast.classList.remove('is-visible');
      toast.setAttribute('aria-hidden', 'true');
    }, 3000);
  };

  const setLoading = (loading) => {
    loader?.classList.toggle('is-visible', loading);
    loader?.setAttribute('aria-hidden', String(!loading));
  };

  window.AuraSyncUI = { showToast, setLoading };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest?.('[data-aura-cross-sell-add]');
    if (!button || button.disabled) return;
    const status = button.closest('[data-aura-cart-cross-sell]')?.querySelector('[data-aura-cross-sell-status]');
    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'ADDING…';
    let added = false;
    setLoading(true);
    try {
      const rootPath = window.Shopify?.routes?.root || '/';
      const addResponse = await fetch(`${rootPath}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1, ...(button.dataset.sellingPlan ? {selling_plan: Number(button.dataset.sellingPlan)} : {}) }] }),
      });
      if (!addResponse.ok) throw new Error('Unable to add this object.');
      added = true;
      if (window.location.pathname === `${rootPath}cart` || window.location.pathname === '/cart') {
        window.location.reload();
        return;
      }
      const sectionResponse = await fetch(`${rootPath}?sections=cart-drawer-section`, { headers: { Accept: 'application/json' } });
      if (!sectionResponse.ok) throw new Error('Cart updated. Reopen the drawer to view it.');
      const sections = await sectionResponse.json();
      const current = document.getElementById('shopify-section-cart-drawer-section');
      if (!current || !sections['cart-drawer-section']) throw new Error('Added. View your cart to review your order.');
      current.outerHTML = sections['cart-drawer-section'];
      const cartResponse = await fetch(`${rootPath}cart.js`, { headers: { Accept: 'application/json' } });
      if (cartResponse.ok) {
        const nextCart = await cartResponse.json();
        document.querySelectorAll('[data-aurasync-cart-count]').forEach((count) => { count.textContent = nextCart.item_count; });
      }
      document.getElementById('cart-drawer')?.open?.();
      showToast(1);
    } catch (error) {
      button.disabled = added;
      button.textContent = added ? 'ADDED' : original;
      if (status) {
        status.textContent = error.message;
        if (added) {
          const link = document.createElement('a');
          link.href = `${window.Shopify?.routes?.root || '/'}cart`;
          link.textContent = ' View cart';
          status.append(link);
        }
      }
    } finally {
      setLoading(false);
    }
  });

  document.addEventListener('change', async (event) => {
    const giftToggle = event.target.closest?.('[data-aura-gift-toggle]');
    if (!giftToggle) return;

    giftToggle.disabled = true;
    setLoading(true);
    const status = giftToggle.closest('[data-aura-gift-container]')?.querySelector('[data-aura-gift-status]');

    try {
      const rootPath = window.Shopify?.routes?.root || '/';
      const response = giftToggle.checked
        ? await fetch(`${rootPath}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(giftToggle.dataset.variantId), quantity: 1 }] }),
          })
        : await fetch(`${rootPath}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: giftToggle.dataset.lineKey, quantity: 0 }),
          });

      if (!response.ok) throw new Error('Unable to update the care package.');
      const [sectionsResponse, cartResponse] = await Promise.all([
        fetch(`${rootPath}?sections=cart-drawer-section`, {headers:{Accept:'application/json'}}),
        fetch(`${rootPath}cart.js`, {headers:{Accept:'application/json'}})
      ]);
      if(!sectionsResponse.ok || !cartResponse.ok) throw new Error('Please review your cart.');
      const sections=await sectionsResponse.json(), cart=await cartResponse.json();
      document.querySelectorAll('[data-aurasync-cart-count]').forEach(node=>{node.textContent=cart.item_count;});
      const wrapper=document.getElementById('shopify-section-cart-drawer-section');
      if(wrapper && sections['cart-drawer-section']){
        wrapper.outerHTML=sections['cart-drawer-section'];
        const drawer=document.getElementById('cart-drawer');
        if(typeof drawer?.open==='function')drawer.open();else window.location.assign(`${rootPath}cart`);
      }else window.location.assign(`${rootPath}cart`);
    } catch (error) {
      // A response or refresh failure may follow a successful mutation. Never retry a stale checkbox.
      if(status){status.classList.remove('visually-hidden');status.textContent='Update needs review. ';const link=document.createElement('a');link.href=`${window.Shopify?.routes?.root || '/'}cart`;link.textContent='View cart';status.append(link);}
    } finally { setLoading(false); }
  });

  setTheme(localStorage.getItem('aurasync-theme') === 'shutdown' ? 'shutdown' : 'light');
  themeButton?.addEventListener('click', () => setTheme(root.dataset.auraTheme === 'shutdown' ? 'light' : 'shutdown'));
  baseline?.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  window.addEventListener('scroll', () => baseline?.classList.toggle('is-visible', window.scrollY > window.innerHeight * 0.8), { passive: true });


  if (!header) return;

  const updateHeader = () => {
    header.classList.toggle('is-scrolled', window.scrollY > 12);
  };

  const setDrawer = (open) => {
    if (!drawer || !openButton) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    openButton.setAttribute('aria-expanded', String(open));
    document.documentElement.style.overflow = open ? 'hidden' : '';

    if (open) {
      drawer.querySelector('[data-aurasync-menu-close]')?.focus();
    } else {
      openButton.focus();
    }
  };

  // Horizon wraps the header in a sticky section container. Moving the fixed
  // drawer to <body> keeps its height tied to the viewport at every scroll
  // position instead of clipping it to the header group's remaining height.
  if (drawer && drawer.parentElement !== document.body) {
    document.body.appendChild(drawer);
  }

  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
  openButton?.addEventListener('click', () => setDrawer(true));
  closeButtons.forEach((button) => button.addEventListener('click', () => setDrawer(false)));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer?.classList.contains('is-open')) setDrawer(false);
  });

  const revealItems = document.querySelectorAll('[data-aura-reveal]');
  if (revealItems.length) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    } else {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.18, rootMargin: '0px 0px -6% 0px' }
      );
      revealItems.forEach((item) => observer.observe(item));
    }
  }
})();

// Native shipping-code recovery: verify the latest cart before standard checkout.
(() => {
  let busy = false;
  document.addEventListener('click', async event => {
    const button = event.target.closest?.('button[name="checkout"],input[name="checkout"],a[href="/checkout"]');
    if (!button || event.defaultPrevented || event.metaKey || event.ctrlKey) return;
    event.preventDefault();
    if (busy) return;
    busy = true;
    button.setAttribute('aria-busy', 'true');
    const root = window.Shopify?.routes?.root || '/';
    try {
      const response = await fetch(`${root}cart.js`, {headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('Please try checkout again.');
      const cart = await response.json();
      if (!cart.item_count) throw new Error('Your cart is empty. Add an object first.');
      const eligible = cart.item_count >= 2 && cart.items.some(item => item.handle === 'silent-desk-fidget-stone');
      const codes = (cart.discount_codes || []).map(item => item.code).filter(code => code.toUpperCase() !== 'ANCHORPAIRSHIP');
      if (eligible) codes.push('ANCHORPAIRSHIP');
      const update = await fetch(`${root}cart/update.js`, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:codes.join(',')})});
      if (!update.ok) throw new Error('We could not update your shipping offer. Please try checkout again.');
      window.location.assign(`${root}checkout`);
    } catch (error) {
      window.alert(error.message);
      busy = false;
      button.removeAttribute('aria-busy');
    }
  }, true);
})();
